import React, { useState } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

import MuiAccordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { useAccordionStyles, useAccordionSummaryStyles, useAccordionDetailsStyles } from './styles';

const Accordion = ({ children, id, label, cid, defaultExpanded, checked, setchecked, expandIcon, ...rest }) => {
	const classesAccordion = useAccordionStyles();
	const classesAccordionSummary = useAccordionSummaryStyles();
	const classesAccordionDetails = useAccordionDetailsStyles();
	const [expanded, setExpanded] = useState(defaultExpanded || false);

	const handleExpanded = (_event, isExpanded) => {
		setExpanded(isExpanded);
	};

	return (
		<MuiAccordion elevation={0} onChange={handleExpanded} expanded={expanded} {...rest} classes={classesAccordion}>
			<AccordionSummary
				expandIcon={!expandIcon ? <ExpandMoreIcon /> : expandIcon}
				aria-label={label + '-expand'}
				aria-controls={id + '-actions-content'}
				id={id + '-actions-header'}
				classes={classesAccordionSummary}>
				<Typography variant="body1">{parse(label)}</Typography>
			</AccordionSummary>

			<AccordionDetails classes={classesAccordionDetails}>{children}</AccordionDetails>
		</MuiAccordion>
	);
};

Accordion.propTypes = {
	children: PropTypes.node.isRequired,
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	defaultExpanded: PropTypes.bool.isRequired
};

export default Accordion;
